import { render, staticRenderFns } from "./BaseTableDeleteBtn.vue?vue&type=template&id=3a8c29b4&"
import script from "./BaseTableDeleteBtn.vue?vue&type=script&lang=js&"
export * from "./BaseTableDeleteBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports